import { getApp, getApps, initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  isSupported,
  Messaging,
} from "firebase/messaging";

// Firebase config (replace with actual values)
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize Messaging
const messaging = async (): Promise<Messaging | null> => {
  const supported = await isSupported();
  return supported ? getMessaging(app) : null;
};

export const fetchToken = async (): Promise<string | null> => {
  try {
    if (!messaging) {
      console.error("Firebase Messaging is not initialized");
      return null;
    }

    const fcmMessaging = await messaging();
    if (!fcmMessaging) {
      console.error("Firebase Messaging is not supported");
      return null;
    }

    const token = await getToken(fcmMessaging, {
      vapidKey: import.meta.env.VITE_FIREBASE_FCM_VAPID_KEY,
    });

    return token || null;
  } catch (err) {
    console.error("Error fetching FCM token:", err);
    return null;
  }
};


export { app, messaging };